/** Canonical public site origin (www). Page URLs only — not API hosts or @qinvesting.ai emails. */
export const SITE_ORIGIN = 'https://www.qinvesting.ai';
